module.exports = __webpack_public_path__ + "img/icon-record.ff4b012b.svg";